import React from 'react';
import { useSelector } from 'react-redux';
import _ from 'lodash';

export const useWebInstance = () => useSelector(state => _.get(state, 'app.webInstance', {}));
export const useUser = () => useSelector(state => _.get(state, 'user', null));
export const useThemeConfig = () => useSelector(state => _.get(state, 'app.config', null));
